import React, { Component } from 'react'
import currency from 'currency.js'
import { Element as ScrollElement } from 'react-scroll'
import Favorite from '../community/Favorite'
import { InputError, Action } from '@foodsby/nutrient'

export const PastOrderItem = ({
  pastOrder,
  favorites,
  addPastOrderToCart,
  addFavoriteStart,
  deleteFavoriteStart,
  editPastOrder,
  menuItemIdsLoading = [],
}) => (
  <li className="placeorder-item">
    {pastOrder &&
      pastOrder.orderItems.map((orderItem, i) => (
        <div className="row editPastOrderItem" key={orderItem.orderItemId}>
          {favorites &&
          favorites.length >= 1 &&
          favorites.find(
            favorite => favorite.menuItemId === orderItem.menuItemId,
          ) ? (
            <Favorite
              classNames={{ 'placeorder-item_favorite': true }}
              deleteFavoriteStart={deleteFavoriteStart}
              favoriteLoading={menuItemIdsLoading.find(
                menuItem => menuItem.menuItemId === orderItem.menuItemId,
              )}
              id={orderItem.menuItemId}
            />
          ) : (
            <Favorite
              addFavoriteStart={addFavoriteStart}
              classNames={{ 'placeorder-item_favorite': true }}
              favoriteLoading={menuItemIdsLoading.find(
                menuItem => menuItem.menuItemId === orderItem.menuItemId,
              )}
              id={orderItem.menuItemId}
            />
          )}
          <div className="pastOrderSelector">
            <Action
              className="pastOrderSelectorButton"
              onClick={() => {
                editPastOrder(orderItem.hash, null, true)
              }}
            >
              <div className="col-xs-10 placeorder-item_title">
                {orderItem.displayText}{' '}
              </div>
              <div className="col-xs-2 end-xs placeorder-item_price">
                {currency(orderItem.fullSubTotal).format()}
              </div>
              <div className="col-xs-12 placeorder-item_description">
                {orderItem.modifiers
                  .filter(modifier => modifier.answers.length > 0)
                  .map(modifier =>
                    modifier.answers
                      .map(
                        answer =>
                          `${
                            answer.price > 0
                              ? `${answer.displayText} +$${answer.price}`.trim()
                              : `${answer.displayText}`.trim()
                          }`,
                      )
                      .join(', '),
                  )
                  .join(', ')}
              </div>
            </Action>
            {pastOrder &&
            pastOrder.orderItems.length > 1 &&
            i === pastOrder.orderItems.length - 1 ? (
              <div>
                <Action
                  className="pastOrderAddtoCart"
                  onClick={() => addPastOrderToCart(pastOrder)}
                  title="Add Order to Cart"
                >
                  <i className="icon icon-cart secondary" /> Add To Cart
                  {` (${pastOrder.orderItems.length} Items)`}
                </Action>
              </div>
            ) : (
              pastOrder.orderItems.length === 1 && (
                <div>
                  <Action
                    className="pastOrderAddtoCart"
                    onClick={() => addPastOrderToCart(pastOrder)}
                    title="Add Order to Cart"
                  >
                    <i className="icon icon-cart secondary" /> Add To Cart
                  </Action>
                </div>
              )
            )}
          </div>
        </div>
      ))}
  </li>
)

export const PastOrderList = ({
  pastOrders,
  favorites,
  addPastOrderToCart,
  editPastOrder,
  addFavoriteStart,
  deleteFavoriteStart,
  menuItemIdsLoading,
}) => (
  <ul className="placeorder-list">
    {pastOrders &&
      pastOrders.map(pastOrder => (
        <PastOrderItem
          addFavoriteStart={addFavoriteStart}
          addPastOrderToCart={addPastOrderToCart}
          deleteFavoriteStart={deleteFavoriteStart}
          editPastOrder={editPastOrder}
          favorites={favorites}
          key={pastOrder.orderId}
          menuItemIdsLoading={menuItemIdsLoading}
          pastOrder={pastOrder}
        />
      ))}
  </ul>
)

export const NoPastOrders = () => (
  <p className="pastorders-none center-xs">
    You have no past orders for this restaurant.
  </p>
)

class PastOrders extends Component {
  constructor(props) {
    super(props)

    this.state = { pastOrdersOpen: false }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.setState(prevState => ({
      pastOrdersOpen: !prevState.pastOrdersOpen,
    }))
  }

  render() {
    const {
      addFavoriteStart,
      addPastOrderToCart,
      deleteFavoriteStart,
      editPastOrder,
      favorites,
      id,
      menuItemIdsLoading,
      pastOrderError,
      pastOrders,
    } = this.props
    let singlePastOrder
    if (pastOrders && pastOrders.length > 0) {
      singlePastOrder = pastOrders.slice(0, 1)
    }
    return (
      <ScrollElement name="pastorders">
        <section className="placeorder" id={id || ''}>
          <h2 className="popularItemsHeader">Order Again</h2>

          <div className="placeorder">
            {pastOrders && pastOrders.length > 0 ? (
              <PastOrderList
                addFavoriteStart={addFavoriteStart}
                addPastOrderToCart={addPastOrderToCart}
                deleteFavoriteStart={deleteFavoriteStart}
                editPastOrder={editPastOrder}
                favorites={favorites}
                key="pastOrderList"
                menuItemIdsLoading={menuItemIdsLoading}
                pastOrders={
                  !this.state.pastOrdersOpen ? singlePastOrder : pastOrders
                }
              />
            ) : (
              pastOrders && pastOrders.length === 0 && <NoPastOrders />
            )}
            {pastOrders && pastOrders.length > 1 && (
              <div className="row end-xs">
                <div className="col-xs">
                  <Action className="showMoreLink" onClick={this.handleClick}>
                    Show {!this.state.pastOrdersOpen ? 'more' : 'less'}
                  </Action>
                </div>
              </div>
            )}
          </div>
          <InputError>{pastOrderError}</InputError>
        </section>
      </ScrollElement>
    )
  }
}
export default PastOrders
